export default __webpack_public_path__ + "static/media/trus17.1259355a.png";